import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { payoutsApi } from "@/api/payouts.api";
import { queryKeys } from "@/utils/queryKeys";
import type { PayoutStatus } from "@/types/domain";

export function usePayouts(status?: PayoutStatus) {
  return useQuery({
    queryKey: queryKeys.commission.payouts(status),
    queryFn: () => payoutsApi.list({ status, limit: 50 }),
    // Sending payouts flip to Paid when the provider confirms.
    refetchInterval: 15_000,
  });
}

function useInvalidatingMutation<V>(fn: (v: V) => Promise<unknown>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["commission"] }),
  });
}

export const useApprovePayout = () => useInvalidatingMutation((id: string) => payoutsApi.approve(id));
export const useRejectPayout = () =>
  useInvalidatingMutation((v: { id: string; reason: string }) => payoutsApi.reject(v.id, v.reason));
export const useMarkPayoutPaid = () =>
  useInvalidatingMutation((v: { id: string; reference: string }) => payoutsApi.markPaid(v.id, v.reference));
